import { useEffect } from "react"
import "../../styles/dandelions.scss"
import { Menu } from "../components/Menu"
import type { TemplateProps } from "../types"
import { Template } from "../components/Template"

export function DandyTemplate({ title, children }: TemplateProps) {
  useEffect(() => {
    document.title = title
  }, [title])

  return (
    <Template className="dandelionsTemplate">
      <Menu />
      <div className="dandelions">
        {Array.from({ length: 9 }).map((_, i) => (
          <div key={i} className="dandy-track">
            <div className="dandy"></div>
          </div>
        ))}
      </div>
      <div className="content">
        <article>{children}</article>
      </div>
    </Template>
  )
}
